import { ZoomableIframe } from "components/ZoomableIframe"

export const AipVfr = () => (
  <ZoomableIframe src="https://aip.dfs.de/BasicVFR/pages/C00001.html" />
)
